module.exports = __webpack_public_path__ + "static/media/nologo.1b441dde.svg";